import { Text, VStack } from "@chakra-ui/react";
import React from "react";

export default function NotFound() {
  return (
    <VStack w={"100%"} py={4}>
      <Text fontWeight={500} opacity={0.6}>
        Data tidak ditemukan
      </Text>
    </VStack>
  );
}
